import React, {
    Fragment, useState, useEffect, useRef,
} from 'react'

import './styles/menu.scss'

const Menu = ({
    children,
    list,
    cssClass,
    width,
    minWidth,
    dir,
    hasUniqueLast,
    closeAfterSelection,
    onClose,
    disabled,
    showTick,
}) => {
    const wrapperRef = useRef(null)
    const menuRef = useRef(null)
    const [showMenu, setShowMenu] = useState(false)

    const handleClickOutside = (event) => {
        if (!showMenu) return
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowMenu(false)
            if (onClose) onClose()
        }
        if (closeAfterSelection && menuRef.current && menuRef.current.contains(event.target)) {
            setTimeout(() => {
                setShowMenu(false)
                if (onClose) onClose()
            }, 500)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [showMenu])

    const toggleMenu = () => {
        setShowMenu((prevState) => !prevState)
    }

    let menuCss = 'uc-menu'
    menuCss += cssClass ? ` ${cssClass}` : ''
    menuCss += dir ? ` ${dir}` : ''

    const getOptionClass = (index, isDisabled) => {
        if (isDisabled) return 'menu-option-disabled'
        if (hasUniqueLast && ((list.length - 1) === index)) return 'menu-option-greybg'
        if (hasUniqueLast && ((list.length - 2) === index)) return 'menu-option last'
        return 'menu-option'
    }

    return (
        <Fragment>
            <div className={menuCss} ref={wrapperRef}>
                <div
                    className={`menu-target ${showMenu ? 'target-selected' : ''} ${showTick ? 'showTick' : ''}`}
                    onClick={!disabled ? toggleMenu : null}
                >
                    {children}
                </div>
                {showMenu && (
                    <div
                        ref={menuRef}
                        id="menuContainer"
                        className={`menu-container ${list.length > 2 ? 'large' : 'regular'} ${list.length === 1 ? 'one-opt' : ''}`}
                        style={{ width, minWidth }}
                    >
                        {
                            list.map((item, index) => (
                                <div key={`menu-${index}`} className={getOptionClass(index, item.disabled)}>
                                    {item}
                                </div>
                            ))
                        }
                    </div>
                )}
            </div>
        </Fragment>
    )
}

export default Menu
